import { Component } from '@angular/core';
import { NavigationService } from '../../services/nav/navigation.service';
import {
  CampaignControllerService,
  CampaignSummaryDto,
  CampaignTranslationDto,
} from '@api/utisha-backend';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { UtishaGeneralStore } from '../../services/storage/general-store';

import { AccountActionsComponent } from '../account-actions/account-actions.component';
import { UtButtonComponent } from '../../ui';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-campaign-landing',
  templateUrl: './campaign-landing.component.html',
  styleUrls: ['./campaign-landing.component.scss'],
  imports: [AccountActionsComponent, UtButtonComponent, TranslatePipe],
})
export class CampaignLandingComponent {
  campaignName: string;
  campaign: CampaignSummaryDto;
  error = false;
  constructor(
    public nav: NavigationService,
    private utishaGeneralStore: UtishaGeneralStore,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private campaignService: CampaignControllerService,
  ) {
    this.route.params.subscribe((params) => {
      this.campaignName = params.campaign;
      this.refresh();
    });
  }

  private refresh(): void {
    this.campaignService.get(this.campaignName).subscribe(
      async (campaign) => {
        await this.utishaGeneralStore.setCampaign(campaign.name!);
        this.campaign = campaign;
      },
      (err) => this.nav.publicNotFound(),
    );
  }

  get translation(): CampaignTranslationDto {
    const t = this.languageService.getTranslation(
      this.campaign.translations || [],
    );
    return (
      (t
        ? t
        : this.languageService.getDefaultTranslation(
            this.campaign.translations || [],
          )) || ({} as CampaignTranslationDto)
    );
  }

  get title(): string {
    return this.translation.title || 'Campaign';
  }

  get description(): string {
    const translation = this.languageService.getTranslation(
      this.campaign.translations || [],
    );
    return this.translation.description || '';
  }

  get imageUuid(): string | undefined {
    const imageUuid = this.translation.imageUuid;
    return imageUuid || this.campaign.imageUuid;
  }
}
